<template>
  <volcan-sortable
    key="sortable_list"
    v-model="sortableList"
    title="name"
    :class="isSortable ? 'has-sort' : ''"
    :startingSort="startSorting"
    :stoppedSort="stoppedSorting"
    :resetSort="resetSort"
    :isSortable="isSortable"
    :isCancellable="isCancellable"
    :isReinitable="isReinitable"
  >
    <slot>
      <div class="table-wrapper">
        <div class="row justify-content-between table-header">
          <div class="col-md-4 col-sm-12">
            <volcan-add-btn
              v-if="data.addBtn && (!rolesAdd || isAuthorize(rolesAdd))"
              :data="data.addBtn"
            />
          </div>
          <slot name="button" />
          <div
            class="col-xl-4 col-md-6 col-sm-12 filter-margin-sm search-form-ctn"
          >
            <!-- <span class="fa fa-refresh pointer" @click="refresh();"></span> -->
            <volcan-filter-bar
              v-if="data.filter"
              :data="data.filter"
            ></volcan-filter-bar>
          </div>
        </div>
        <slot name="filter" />
        <div id="table-loading-wrapper" style="position: relative;">
          <volcan-loading :loading="loading" />
          <div
            class="refresh-list pointer"
            v-if="data.refreshBtn.show"
            @click="refresh()"
            :title="data.refreshBtn.text"
          >
            <i :class="data.refreshBtn.icon"></i>
          </div>

          <vuetable
            :initial-page="data.page"
            :sort-order="sortOrder"
            :per-page="data.itemPerPage != undefined ? data.itemPerPage : 25"
            :append-params="data.filter != undefined ? data.filter : obj"
            :css="css.table"
            ref="vuetable"
            :api-url="data.apiUrl"
            :fields="fields"
            pagination-path=""
            @vuetable:pagination-data="onPaginationData"
            @vuetable:loading="onLoading"
            @vuetable:loaded="onLoaded"
          >
            <template
              slot="edit"
              slot-scope="props"
              v-if="data.editButton && (!rolesEdit || isAuthorize(rolesEdit))"
            >
              <router-link
                class="text-muted"
                :to="{
                  name: data.editButton.componentName,
                  params: paramEdit(props.rowData)
                }"
                :class="data.editButton.icon"
              />
            </template>

            <template slot="delete" slot-scope="props">
              <a
                @click="deleteRow(props.rowData)"
                class="text-muted fa fa-trash pointer"
              />
            </template>

            <template slot="nameParentChild" slot-scope="props">
              <div
                v-html="getParentChildName(props.rowData)"
                class="parent-child-name-cell"
              ></div>
            </template>
          </vuetable>
        </div>
        <div class="row justify-content-between margin-top">
          <div class="col-md-6 col-sm-12 center-sm">
            <volcan-pagination-info ref="paginationInfo" />
          </div>
          <div class="col-md-6 col-sm-12">
            <volcan-pagination
              :css="css.pagination"
              ref="pagination"
              @vuetable-pagination:change-page="onChangePage"
            />
          </div>
        </div>
        <volcan-modal :data="deleteModalInfo" :action="deleteItem" />
      </div>
    </slot>
  </volcan-sortable>
</template>
<script>
import apitools from '@mixins/apitools.js';
import Vue from 'vue';
import compte from '@mixins/compte.js';
import helpers from '@mixins/helpers.js';
export default {
  props: {
    data: { type: Object },
    alert: { type: Object },
    rolesAdd: { type: Array },
    rolesDelete: { type: Array },
    rolesEdit: { type: Array },
    rolesEdit: { type: Array },
    isSortable: { type: Boolean, default: false },
    isCancellable: { type: Boolean, default: false },
    isReinitable: { type: Boolean, default: false }
  },
  name: 'volcan-data-table',
  mixins: [apitools, compte, helpers],
  data: function() {
    return {
      sortableList: [],
      isSorting: false,
      item: {},
      deleteModalInfo: {
        title: 'Attention!',
        cancel: 'Non',
        ok: 'Oui',
        msg: '',
        item: {},
        popup: false
      },
      sortOrder: [],
      loading: true,
      obj: {},
      css: {
        table: {
          tableClass:
            'table table-striped table-bordered table-hover table-responsive center-table w-100 d-block d-sm-table',
          loadingClass: 'loading',
          ascendingIcon: 'fa fa-sort-up',
          descendingIcon: 'fa fa-sort-down',
          sortableIcon: 'fa fa-sort text-muted icon',
          handleIcon: 'glyphicon glyphicon-menu-hamburger'
        },
        pagination: {
          infoClass: 'pull-left',
          wrapperClass: 'vuetable-pagination pull-right center-sm',
          activeClass: 'btn-secondary',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      }
    };
  },
  computed: {
    isDefaultViewForName() {
      return this.sortOrder.length === 0 && this.data.filter.filter === '';
    },
    fields() {
      var fields = [];
      if (this.data.editButton) {
        fields.push({
          dataClass: 'edit-delete-row',
          title: '',
          name: '__slot:edit'
        });
      }
      fields = fields.concat(this.data.fields);

      if (
        this.$user &&
        this.$user.roles &&
        this.rolesDelete &&
        !this.isAuthorize(this.rolesDelete)
      ) {
        if (this.data.deleteBtn) {
          fields.push({
            dataClass: 'edit-delete-row',
            title: '',
            name: '__slot:delete',
            visible: false
          });
        }
      } else {
        if (this.data.deleteBtn) {
          fields.push({
            dataClass: 'edit-delete-row',
            title: '',
            name: '__slot:delete',
            visible: true
          });
        }
      }

      return fields;
    }
  },
  watch: {
    'data.filter': {
      handler() {
        this.$refs.vuetable.refresh();
      },
      deep: true
    }
  },
  mounted() {},
  methods: {
    getParentChildName(rowData) {
      return `${this.getName(rowData)}${this.getParentNames(rowData)}`;
    },
    getName(rowData) {
      if (!this.isDefaultViewForName || rowData.parentId === null) {
        return `<span class="parent">${rowData.name}</span>`;
      }
      var lPadding = rowData.childDepth * 20;
      return `<span class="parent-child-${rowData.childDepth}" style="padding-left: ${lPadding}px;">${rowData.name}</span>`;
    },
    getParentNames(rowData) {
      if (this.isDefaultViewForName || rowData.parentId === null) {
        return '';
      }

      return `<div class="parent-list">${rowData.parentNames}</div>`;
    },
    refresh() {
      this.sortOrder = [];
      Vue.nextTick(e => {
        this.$refs.vuetable.refresh();
      });
    },
    paramEdit(rowData) {
      var param = {};

      if (this.data.editButton.paramProperties != undefined) {
        this.data.editButton.paramProperties.forEach(item => {
          param[item.key] = rowData[item.name];
        });
      }

      if (this.data.editButton.paramPropertiesStatic != undefined) {
        this.data.editButton.paramPropertiesStatic.forEach(item => {
          param[item.key] = item.name;
        });
      }

      return param;
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      const urlParams = new URLSearchParams(window.location.search);
      const pageUrl = urlParams.get('page');

      if (pageUrl) {
        var newUrl = location.href.replace('page=' + pageUrl, 'page=' + page);
        window.history.pushState('page', 'search', newUrl);
      } else {
        var extramParam = '';
        var params = window.location.search.substr(1);
        if (params) {
          var extramParam = '&' + params;
        }
        window.history.pushState(
          'page',
          'search',
          '?page=' + page + extramParam
        );
      }

      this.$refs.vuetable.changePage(page);
    },
    deleteRow(rowData) {
      this.item = rowData;
      this.deleteModalInfo.item = rowData;
      this.deleteModalInfo.msg = this.$parseEsTemplate.parse(
        this.$t(this.data.deleteConfirmationMessageI18n),
        this
      );

      this.deleteModalInfo.popup = true;
    },
    deleteItem(rowData) {
      axios.delete(this.data.deleteBtn.apiUrl + rowData.id).then(response => {
        this.getAndSetBadgeCountForModule(this.data.moduleName);

        this.alert.success = true;
        this.alert.message = this.$parseEsTemplate.parse(
          this.$t(this.data.deletedMessageI18n),
          this
        );

        this.$refs.vuetable.refresh();
      });
    },
    onLoading() {
      this.loading = true;
    },
    onLoaded() {
      this.loading = false;
    },
    startSorting() {
      this.isSorting = true;
      this.onLoading();

      axios
        .get(`${this.data.apiUrl}datasort`)
        .then(response => {
          this.sortableList = response.data.data;
          this.onLoaded();
        })
        .catch(error => {
          // this.$logError('apitools.getAndSetBadgeCountForModule', error, `Error ${url}`)
          console.log(`Crashed on datasort`);
          console.log(error);
        });
    },
    stoppedSorting(list) {
      axios
        .put(`${this.data.apiUrl}datasort`, this.sortableList)
        .then(response => {
          this.refresh();
          this.isSorting = false;
        })
        .catch(error => {
          // this.$logError('apitools.getAndSetBadgeCountForModule', error, `Error ${url}`)
          console.log(`Crashed on datasort`);
          console.log(error);
        });
    },
    resetSort() {
      axios
        .delete(`${this.data.apiUrl}datasort`, this.sortableList)
        .then(response => {
          this.refresh();
          this.isSorting = false;
        })
        .catch(error => {
          // this.$logError('apitools.getAndSetBadgeCountForModule', error, `Error ${url}`)
          console.log(`Crashed on datasort`);
          console.log(error);
        });
    }
  }
};
</script>
<style lang="scss">
@import '../../../Shared/Layout/Assets/sass/base/_variables.scss';

.table-wrapper {
  padding: 20px;
}

.pointer {
  cursor: pointer;
}

.refresh-list {
  position: absolute;
  padding: 8px 15px;
  color: $white;
}

.refresh-list:hover {
  color: $black;
}

.edit-delete-row {
  width: 40px;
  padding: 0 !important;
}

.edit-delete-row a {
  height: 100%;
  width: 100%;
  padding: 12px 13px;
}

.table-header {
  margin-bottom: 20px;
}

.parent-list {
  position: absolute;
  bottom: -0.8em;
  font-size: 0.7em;
  padding-left: 0.7em;
  color: $lightblue;
}

.parent-child-name-cell {
  position: relative;
}

@media (max-width: 767px) {
  .filter-margin-sm {
    margin-top: 20px;
  }

  .center-sm {
    text-align: center;
    float: none;
  }
}

//Custom TH
#_createdOnUtc {
  width: 170px;
}

#_updatedOnUtc {
  width: 220px;
}

#_isActive {
  width: 110px;
}

// @for $i from 0 through 10 {
//   .parent-child-#{$i} {
//     // font-weight: bold;
//   }
// }

.parent {
  font-weight: bold;
}

.trDisabled {
  background-color: #ffcccc !important;
}

.nameDisplay {
  margin-bottom: 0;
}

.regionsDisplay {
  margin-top: 5px;
  margin-bottom: 0;
  font-size: 13px;
  color: $darkblue;
}

.center-text {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// components/AdminTools/dataTable/index.vue